<template>
    <div class="-m-5 md:m-0 h-full flex-1 overflow-hidden">
        <tabulator
            :columns="columns"
            :actions="actions"
            :ajax-params="ajaxParams"
            :refresh.sync="refreshTable"
            :loading="tableIsLoading"
            :showHeader="showTableHeader"
            :pagination="paginateTable"
            ajax-path="nable/issues"
            @rowSelected="handleRowSelected"     
        />
    </div>
</template>

<script>
    import http from '@/helpers/Http';
    export default {
        props: {
            showTableHeader: {
                type: Boolean,
                default: true,
            },
            paginateTable: {
                type: Boolean,
                default: true,
            }
        },
        data() {
            return {
                tableIsLoading: false,
                refreshTable: false,
                ajaxParams:{},
                columns: [
                    {
                        title: 'Customer',
                        field: 'customername',
                        sorter: 'string',
                        minWidth: 250,
                    },
                    {
                        title: 'Site',
                        field: 'sitename',
                        sorter: 'string',
                        minWidth: 150,
                        formatter({_cell}) {
                            if (_cell.value) {
                                return _cell.value;
                            }

                            return '--';
                        },
                    },
                    {
                        title: 'Device/Probe',
                        field: 'devicename',
                        sorter: 'string',
                        minWidth: 250,
                        formatter({_cell}) {
                            if (_cell.value) {
                                return _cell.value;
                            }

                            return '--';
                        },
                    },                    
                    {
                        title: 'Device Class',
                        field: 'deviceclass',
                        sorter: 'string',
                        minWidth: 200,
                    },
                    {
                        title: 'Service',
                        field: 'servicename',
                        sorter: 'string',
                        minWidth: 250,
                    },
                    {
                        title: 'Transition Time',
                        field: 'transition_time_for_human',
                        sorter: 'string',
                        minWidth: 250,
                    },
                ],
                actions: [
                    // {
                    //     label: 'Sync',
                    //     icon: () => import('@/icons/Sync.vue'),
                    //     handler: this.sync
                    // }
                ],
            }
        },
        methods: {
            handleRowSelected(selected) {

            },
            sync() {
                this.tableIsLoading = true;
                http.patch('nable/issues/sync')
                    .then(() => {
                        this.tableIsLoading = false;
                        this.refreshTable = true;
                    })
                    .catch(() => {
                        this.tableIsLoading = false;
                    })
            }
        }
    }
</script>